import styled from 'styled-components';
import { Breakpoints, css, CTA } from '@volkswagen-onehub/components-core';

export const StyledStickyBottomNav = styled.div`
  position: sticky;
  bottom: 0px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.background.primary};

  z-index: 2;
`;

export const BottomNavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  padding: 0 16px;
  padding-bottom: 16px;

  @media (min-width: ${Breakpoints.b560}px) {
    padding: 0 32px;
    padding-bottom: 16px;
  }
`;

export const CTACircularBorder = styled(CTA)<{ $disabled?: boolean }>`
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.content.active};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 16px;
  position: relative;
  z-index: 1;
  background: transparent !important;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  height: 62px;
  width: 62px;

  padding-top: 18px;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.3;
      pointer-events: none;
    `}

  svg {
    color: ${(props) => props.theme.colors.content.active};
    pointer-events: none;
    transition: color 0.2s ease;
  }

  ${({ $disabled, theme }) =>
    !$disabled &&
    css`
      &:hover {
        background: ${theme.colors.accent.nbab.hover} !important;
        svg {
          color: ${theme.colors.content.buttonHover} !important;
        }
      }

      &:active {
        background: ${theme.colors.accent.nbab.hover} !important;
        svg {
          color: ${theme.colors.content.buttonHover} !important;
        }
      }
    `}
`;
